export default __webpack_public_path__ + "static/media/win.fc702605.ogg";